import { render, staticRenderFns } from "./KisDepartmentList.vue?vue&type=template&id=024a0d00"
import script from "./KisDepartmentList.js?vue&type=script&lang=js&external"
export * from "./KisDepartmentList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports